import { SystemTableError, SystemTableErrorType } from '../errors/systemTableError';
import { IProjectConfig } from '../interface/config/project-config.interface';
import { IExtra4Map } from '../interface/permitRequest.interface';
import { 
    REACT_APP_BASE_PERMIT_API_URL, REACT_APP_BASE_PERMIT_API_URL_NEW_API 
} from "../axios/axios-api";
import axios from 'axios';
 

const GET_PORTAL_CONFIG_DETAILS_API = '/systemTables/portal-project-config';

export interface IGetProjectConfigDetailsApiResponse {
    isSuccess: boolean;
    message: string;
    projectConfig: IProjectConfig;
}


const useGetSystemTableApi = () => {

    async function getProjectConfigDetailsApi(token: string, isNewApi: boolean): Promise<IGetProjectConfigDetailsApiResponse> {

        const baseURL = isNewApi ? REACT_APP_BASE_PERMIT_API_URL_NEW_API : REACT_APP_BASE_PERMIT_API_URL;

        const projectConfigRes: IGetProjectConfigDetailsApiResponse = {
            isSuccess: true,
            message: '',
            projectConfig: null
        };

        try {

            const response = await axios.get(GET_PORTAL_CONFIG_DETAILS_API, {
                baseURL: baseURL,
                headers: { Authorization: `Bearer ${token}` }
            });

            isProjectConfigResponseValid(response.data);
            
            const data: IProjectConfig = response.data;

            const permitTypes = { ...data.addRequestPageConfig.permitTypes };

            permitTypes.business = permitTypes.business ?? false;
            permitTypes.permitByZone = permitTypes.permitByZone ?? false;
            permitTypes.noneResident = permitTypes.noneResident ?? false;
            data.addRequestPageConfig.permitTypes = permitTypes;

            console.log('permitTypes:', permitTypes);
            projectConfigRes.projectConfig = data;

        } catch (error) {

            projectConfigRes.isSuccess = false;
            projectConfigRes.message = error instanceof Error ? error.message : 'An unknown error occurred while fetching project config details';
        }

        console.log('getProjectConfigDetailsApi response:', projectConfigRes);
        return projectConfigRes;
    }

    return getProjectConfigDetailsApi;

    function isProjectConfigResponseValid(data: any) {

        if (!data) throw new SystemTableError(SystemTableErrorType.NO_DATA, 'No data in response');


        if (!data.hasOwnProperty('colors') || !Array.isArray(data.colors)) {
            throw new SystemTableError(SystemTableErrorType.MISSING_PROPERTIES, 'colors is not a valid array');
        }

        if (!data.hasOwnProperty('makers') || !Array.isArray(data.makers)) {
            throw new SystemTableError(SystemTableErrorType.MISSING_PROPERTIES, 'makers is not a valid array');
        }

        if (!data.hasOwnProperty('streets') || !Array.isArray(data.streets)) {
            throw new SystemTableError(SystemTableErrorType.MISSING_PROPERTIES, 'streets is not a valid array');
        }

        if (!data.hasOwnProperty('vehicleGroups') || !Array.isArray(data.vehicleGroups)) {
            throw new SystemTableError(SystemTableErrorType.MISSING_PROPERTIES, 'vehicleGroups is not a valid array');
        }

        if (!data.hasOwnProperty('projectId') || typeof data.projectId !== 'number') {
            throw new SystemTableError(SystemTableErrorType.MISSING_PROPERTIES, 'projectId is missing required properties');
        }

        if (!data.hasOwnProperty('engName') || typeof data.engName !== 'string') {
            throw new SystemTableError(SystemTableErrorType.MISSING_PROPERTIES, 'engName is missing required properties');
        }

        if (!data.hasOwnProperty('hebName') || typeof data.hebName !== 'string') {
            throw new SystemTableError(SystemTableErrorType.MISSING_PROPERTIES, 'hebName is missing required properties');
        }

        if (!data.hasOwnProperty('cityLogUrl') || typeof data.cityLogUrl !== 'string') {
            throw new SystemTableError(SystemTableErrorType.MISSING_PROPERTIES, 'cityLogUrl is missing required properties');
        }

        //******** HomePageConfig ********\\

        const homePageConfig = data.homePageConfig;

        if (!isIHomePageConfig(homePageConfig)) {
            throw new SystemTableError(SystemTableErrorType.INVALID_DATA, 'homePageConfig is not a valid object');
        }


        //******** AddRequestPageConfig ********\\
        const addRequestPageConfig = data.addRequestPageConfig;

        if (!isIAddRequestPageConfig(addRequestPageConfig)) {
            throw new SystemTableError(SystemTableErrorType.INVALID_DATA, 'addRequestPageConfig is not a valid object');
        }

    }

    function isIHomePageConfig(obj: any): boolean {

        console.log('isIHomePageConfig input:', obj);

        if (!obj) {
            console.log('isIHomePageConfig: obj is falsy');
            return false; //throw new SystemTableError(SystemTableErrorType.NO_DATA, 'homePageConfig is not IHomePageConfig');
        }

        if (typeof obj !== 'object') {
            console.log('isIHomePageConfig: obj is not an object');
            return false;
        }

        if (obj.hasOwnProperty('sendingCitizenOtpCodeVia') && typeof obj.sendingCitizenOtpCodeVia !== 'string') {
            console.log('isIHomePageConfig: sendingCitizenOtpCodeVia is not a string');
            return false;
        }

        if (obj.hasOwnProperty('hasNewRequestOption') && typeof obj.hasNewRequestOption !== 'boolean') {
            console.log('isIHomePageConfig: hasNewRequestOption is not a boolean');
            return false;
        }

        if (obj.hasOwnProperty('hasAddFileToRequestOption') && typeof obj.hasAddFileToRequestOption !== 'boolean') {
            console.log('isIHomePageConfig: hasAddFileToRequestOption is not a boolean');
            return false;
        }

        if (obj.hasOwnProperty('hasCheckRequestStatusOption') && typeof obj.hasCheckRequestStatusOption !== 'boolean') {
            console.log('isIHomePageConfig: hasCheckRequestStatusOption is not a boolean');
            return false;
        }

        if (obj.hasOwnProperty('hasCheckRequestStatusOption') && typeof obj.hasCancelPermitOption !== 'boolean') {
            console.log('isIHomePageConfig: hasCancelPermitOption is not a boolean');
            return false;
        }

        if (obj.hasOwnProperty('hasCheckValidityPeriodOption') && typeof obj.hasCheckValidityPeriodOption !== 'boolean') {
            console.log('isIHomePageConfig: hasCheckValidityPeriodOption is not a boolean');
            return false;
        }

        if (obj.hasOwnProperty('hasUpdateVehicleDetailsOption') && typeof obj.hasUpdateVehicleDetailsOption !== 'boolean') {
            console.log('isIHomePageConfig: hasUpdateVehicleDetailsOption is not a boolean');
            return false;
        }

        if (obj.hasOwnProperty('hasRenewedPermitOption') && typeof obj.hasRenewedPermitOption !== 'boolean') {
            console.log('isIHomePageConfig: hasRenewedPermitOption is not a boolean');
            return false;
        }

        console.log('isIHomePageConfig: validation passed');
        return true;
    }

    function isIAddRequestPageConfig(obj: any): boolean {

        console.log('isIAddRequestPageConfig input:', obj);

        if (!obj) {
            console.error('isIAddRequestPageConfig: value is empty');
            return false;
        }

        if (typeof obj !== 'object' || Array.isArray(obj)) {
            console.error('isIAddRequestPageConfig: expected an object, received:', typeof obj);
            return false;
        }

        const properties = [
            ['hasAdditionalAddress', 'boolean'],
            ['colorAndType', 'boolean'],
            ['hasAdditionalPersonIdFile', 'boolean'],
            ['gilHaZahavAge', 'number'],
        ];

        for (const [property, expectedType] of properties) {
            const value = obj[property];
            console.log(`isIAddRequestPageConfig: ${property}`, {
                value,
                actualType: value === null ? 'null' : typeof value,
                expectedType,
            });

            if (typeof value !== expectedType) {
                console.error(`isIAddRequestPageConfig: ${property} must be ${expectedType}`);
                return false;
            }
        }


        // **** IPermitTypes **** \\
        const permitTypes = obj.permitTypes;

        console.log('isIAddRequestPageConfig: permitTypes:', permitTypes);

        if (!permitTypes || typeof permitTypes !== 'object' ||
            typeof permitTypes.regular !== 'boolean' ||
            typeof permitTypes.golden !== 'boolean' ||
            typeof permitTypes.student !== 'boolean' ||
            typeof permitTypes.handicapped !== 'boolean' ||
            typeof permitTypes.municipalEmployee !== 'boolean'
        ) {
            console.error('isIAddRequestPageConfig: permitTypes contains an invalid value or type', permitTypes);
            return false;
        }


        // **** IExtraFiles **** \\
        const extraFiles = obj.extraFiles;

        console.log('isIAddRequestPageConfig: extraFiles:', extraFiles);

        if (!extraFiles || typeof extraFiles !== 'object' ||
            typeof extraFiles.hasExtraFile !== 'boolean' ||
            typeof extraFiles.hasRentingApartmentFiles !== 'boolean' ||
            typeof extraFiles.hasBusinessFiles !== 'boolean'
        ) {
            console.error('isIAddRequestPageConfig: extraFiles contains an invalid value or type', extraFiles);
            return false;
        }


        // **** initFormData IExtra4Map **** \\
        const initFormData = obj.initFormData;

        console.log('isIAddRequestPageConfig: initFormData:', initFormData);

        if (!isIInitFormData(initFormData)) {
            console.error('isIAddRequestPageConfig: initFormData is invalid');
            return false;
        }

        console.log('isIAddRequestPageConfig: validation passed');
        return true;
    }

    function isIInitFormData(initFormData: any): boolean {

        console.log('isIInitFormData: validating', initFormData);
        if (!initFormData) return false;

        if (typeof initFormData !== 'object' || (initFormData.hasOwnProperty('extra4') && !isIExtra4Map(initFormData.extra4))) 
            return false;

        return true;
    }

    function isIExtra4Map(extra4Map: any): extra4Map is IExtra4Map {
        // Check if the input is an object and not null
        if (typeof extra4Map !== 'object' || extra4Map === null) {
            return false;
        }

        // Check if all keys and values in the object are strings
        for (const key in extra4Map) {
            if (typeof key !== 'string' || typeof extra4Map[key] !== 'string') {
                return false;
            }
        }

        return true;
    }
}

export default useGetSystemTableApi;